import styled from "styled-components";
import { useState } from "react"
import NewReactDropdown from "../../common/ReactDropdownImproved";
import {positions} from "../../../content-options/positions/userPositions"
import { FC} from "react";

interface Props {
    closeFunc: () => void;
    title: string;
    submitFunc: (value: string) => void;
    dropdownTitle: string;
}

const EditDropdownContainer: FC<Props> = ({ closeFunc, title, submitFunc, dropdownTitle }) => {

    const [option, setOption] = useState<any | undefined>();

    const handleSubmit = () => {
        submitFunc(option)
        closeFunc()
    }
    const handleSelect = (options: any) => {
        setOption(options?.label)
    }

    return (
        <Wrapper>
        <Container>
            <HeaderContainer>
                <Header>{title}</Header>
            </HeaderContainer>
            <BodyContainer>
                <Body>
                    {/* // add func={alert} here */}
                    <NewReactDropdown text={dropdownTitle} options={positions} func={handleSelect}/>
                </Body>
            </BodyContainer>
            <FooterContainer>
                <Footer>
                    <Button className="btn btn-success btn-sm" onClick={handleSubmit}>SAVE</Button>
                    <Button className="btn btn-secondary btn-sm" onClick={closeFunc}>Close</Button>
                </Footer>
            </FooterContainer>
        </Container>
        </Wrapper>
    )
}

export default EditDropdownContainer

const Wrapper = styled.div`
width: 100%;
display: flex;
justify-content: center;
`
const Container = styled.div`
background-color: rgba(38,38,38,1);
text-align: center;
padding: 0 0.5rem;
min-width: 250px;
border-radius: 4px;
position: absolute;
`
const HeaderContainer = styled.div`
`
const Header = styled.h6`
padding: 0.5rem 1rem;
margin: 0;
color: white;
`
const BodyContainer = styled.div`
`
const Body = styled.div`
background-color: rgba(117,117,117,1);
padding: 0.5rem 1rem;
border-radius: 2px;
`

const FooterContainer = styled.div`
`
const Footer = styled.div`
padding: 0.4rem 0;
display: flex;
justify-content: center;
gap: 0.5rem;
`
const Button = styled.button`
`
